import { FieldHookConfig, useField } from 'formik';
import {
  UnitType,
  UnitTypePicker,
  UnitTypePickerProps,
} from '../pickers/AutocompletePickers/UnitTypePicker';

export const FormUnitTypeTypePicker = (
  props: FieldHookConfig<UnitType | null> &
    Omit<UnitTypePickerProps, 'onChange'>,
) => {
  const [field, meta, helpers] = useField<UnitType | null>(props);
  const handleChange = val => {
    props.onChange?.(val);
    helpers.setValue(val, true);
  };
  return (
    <UnitTypePicker
      predicates={props.predicates}
      name={props.name}
      placeholder={props.placeholder}
      disabled={props.disabled}
      label={props.label}
      onChange={handleChange}
      onBlur={field?.onBlur}
      value={field.value}
      error={meta?.error !== undefined}
      helperText={meta.error}
      fullWidth={props.fullWidth}
      $select={props.$select}
      variant="filled"
    />
  );
};
